import * as React from "react";
const SvgChangeHistoryOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M12 7.77 18.39 18H5.61L12 7.77M12 4 2 20h20L12 4z" />
  </svg>
);
export default SvgChangeHistoryOutlined;
